import React from 'react';
import { Eye } from 'lucide-react';

/**
 * Persistent banner shown at the top of every screen while browsing as a
 * demo user, so viewers never forget they're in a sandbox.
 */
const DemoBanner = () => (
  <div
    className="bg-gradient-to-r from-amber-400 to-orange-400 text-[#1A1209] text-xs font-semibold px-3 py-1.5 flex items-center justify-center gap-2 shadow-sm"
    data-testid="demo-mode-banner"
  >
    <Eye size={14} />
    <span>DEMO — HiBFF Preview for Partners</span>
  </div>
);

export default DemoBanner;
